// extracted by mini-css-extract-plugin
export default {"layout":"NoSidebar_layout__RMOUm","container":"NoSidebar_container__+O7LC","url":"NoSidebar_url__Tcujo","lock":"NoSidebar_lock__Up6Yq","content":"NoSidebar_content__Sudhn"};